import { useCheckIsUpdatePeriod } from '../../../../../components/update-period-announcement-panel';
import { useUser } from '../../../../../user-management';
import {
  AddClassroomDropdown,
  AddClassroomDropdownOption,
  ClassroomDropdownOptions,
} from '../../../../components/add-classroom-dropdown';
import { useManageClassrooms } from '../../../../hooks/use-manage-classrooms';
import { useSchoolCapabilities } from '../../../../hooks/use-school-capabilities';

function SchoolJourneysDropdown(): JSX.Element | null {
  const {
    classrooms: { canCreateJourneys },
  } = useSchoolCapabilities();
  const { user } = useUser();
  const isUpdatePeriod = useCheckIsUpdatePeriod();
  const { handleOnError } = useManageClassrooms();

  if (!canCreateJourneys) {
    return null;
  }

  const options: AddClassroomDropdownOption[] = [
    ClassroomDropdownOptions.ADD_JOURNEY,
  ];

  return (
    <AddClassroomDropdown
      size="M"
      disabled={!user || isUpdatePeriod}
      options={options}
      onError={handleOnError}
    />
  );
}

export { SchoolJourneysDropdown };
